<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-10-10 10:55:44
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-10 14:12:48
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/views/jbh/form.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div style="padding: 20px;">
    <p class="title">{{ meetDetail.name }}</p>

    <el-descriptions class="margin-top" title="" :column="1" :size="size" border>
      <el-descriptions-item label="活动主题">
        {{ meetDetail.name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          活动时间
        </template>
        {{ meetDetail.startTimeStr }} - {{ meetDetail.endTimeStr }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          活动地点’
        </template>
        {{ meetDetail.venueName }} - {{ meetDetail.meetingRoom }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          主办单位
        </template>

        <div v-if="sponsorsList.length > 0">
          <template v-for="(item, index) in sponsorsList">
            <div class="name" style="color: #333; font-weight: bold;">{{ item.typeName }}：</div>
            <div>
              <template v-for="(sitem, sindex) in item.infoVos">
                {{ sitem.name }}
              </template>
            </div>
          </template>
        </div>

      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          活动简介
        </template>
        {{ meetDetail.introduction.remark }}
      </el-descriptions-item>
      <el-descriptions-item style="">
        <template slot="label">
          嘉宾人选
        </template>
        <div v-for="(item, index) in guestInfoList" :key="index">
          <span class="name" style="margin-right: 5px;">{{ item.name }}</span>
          <span v-if="item.introduction && !item.organization">{{ item.introduction }}</span>
          <span class="job" v-else>{{ item.organization }}{{ item.department }} {{ item.position }}</span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          议题方向
        </template>
        {{ meetDetail.agendaType }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          活动议程
        </template>
        <div v-for="(item, index) in meetDetail.meetingScheduleDtos" :key="index">
          <span class="name" style="margin-right: 5px;">{{ item.startHmStr }} - {{ item.endHmStr }}</span>
          <span class="job">{{ item.title }} {{ item.description }}</span>
          <div v-for="(sitem, sindex) in item.guestInfoList" :key="sindex">
            <span class="name" style="margin-right: 5px;">{{ sitem.name }}</span>
            <span v-if="sitem.introduction && !sitem.organization">{{ sitem.introduction }}</span>
            <span class="job" v-else>{{ sitem.organization }}{{ sitem.department }} {{ sitem.position }}</span>
          </div>


          <template v-if="item.subScheduleDto && item.subScheduleDto.length > 0">

            <div v-for="(ssitem, ssindex) in item.subScheduleDto" :key="ssindex">
              <span class="name" style="margin-right: 5px;">{{ ssitem.startHmStr }} - {{ ssitem.endHmStr }}</span>
              <span class="job">{{ ssitem.title }} {{ ssitem.description }}</span>
              <div v-for="(sssitem, sssindex) in ssitem.guestInfoList" :key="sssindex">
                <span class="name" style="margin-right: 5px;">{{ sssitem.name }}</span>
                <span v-if="sssitem.introduction && !sssitem.organization">{{ sssitem.introduction }}</span>
                <span class="job" v-else>{{ sssitem.organization }}{{ sssitem.department }} {{ sssitem.position }}</span>
              </div>

            </div>
          </template>


        </div>
      </el-descriptions-item>

    </el-descriptions>

  </div>
</template>

<script>
import { GetQueryString } from '@/utils/utils.js'
export default {
  name: 'form',

  data() {
    return {
      size: 'medium',
      meetDetail: {},
      sponsorsList: [],
      guestInfoList: [],
    }
  },

  mounted() {
    this.meetCode = GetQueryString('meetCode')
    this.headerClientInfo = { language: 'CN', eventKey: 'J80A84ZBBA40PW1', appKey: 'WX_MINI_JBH' }
    let url = `${process.env.VUE_APP_BASE_API}/user/hold/meeting/detail/${this.meetCode}`
    const config = {
      method: 'get',
      url: url,
      headers: {
        'x-call-client-info': JSON.stringify(this.headerClientInfo),
      },
    }

    this.$http(config).then((res) => {
      console.log(res)
      let data = res.data
      data.introduction = data.introduction ? JSON.parse(data.introduction) : ''
      this.meetDetail = data

      let guestList = []
      for (let i of data.meetingScheduleDtos) {
        console.log(i)
        guestList = guestList.concat(i.guestInfoList)
      }
      console.log(guestList)
      this.guestInfoList = guestList
    })

    const config1 = {
      method: 'get',
      url: `${process.env.VUE_APP_BASE_API}/user/meeting/sponsors/getDetail/${this.meetCode}`,
      headers: {
        'x-call-client-info': JSON.stringify(this.headerClientInfo),
      },
    }
    this.$http(config1).then((res) => {
      console.log(res)
      this.sponsorsList = res.data
    })
  },

  methods: {},
}
</script>

<style lang="less" >
.el-descriptions-item__label {
  min-width: 100px;
}
</style>


<style lang="less" scoped>
.title {
  font-weight: bold;
  color: #333;
  font-size: 18px;
}

.margin-top {
  margin-top: 20px;
  width: 100%;
}
</style>